import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterConstants } from "../../../../../redux/constants";
import CustomCheckBox from "../../../../customCheckBox";
import { useTranslation } from "react-i18next";
const { VINTAGE } = filterConstants;

const VintageFilter = ({ applyFilter, fabric }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _filter = useSelector((state) => state.filter);
  const applyVintage = (check) => {
    dispatch({
      type: VINTAGE,
      payload: check,
    });
    applyFilter(9, check && new fabric.Image.filters.Vintage());
  };
  return (
    <div>
      <CustomCheckBox
        lable={t("VintageFilter.Vintage")}
        checked={_filter.vintage}
        onClick={(e) => applyVintage(e.target.checked)}
      />
    </div>
  );
};

export default VintageFilter;
